$(document).ready(function() {

    $('#testimonial-carousel').owlCarousel({
        loop: true,
        margin: 30,
        nav: false,
     	autoplay:true,
		autoplayTimeout:10000,
        pagination: false,
        dots: true,
        items: 3,
        responsive:{
        0:{
            items:1
        },
        768:{
            items:2
        },
        1000:{
            items:3
        }
    }
    });

    /* Sticky Header */
    $(window).scroll(function() {
        var headpos = $(".logo-wrapper").height() + 24;
        if ($(window).width() >= 1024) {
            if ($(window).scrollTop() >= headpos) {
                $("#sticky-head").addClass("sticky")
            } else {
                $("#sticky-head").removeClass("sticky")
            }
        }
    });

  $(".popup img").click(function () {

console.log("click");
    	var $src = $(this).attr("src");
      $(".show-img").fadeIn();
      $(".img-show img").attr("src", $src);
  });

  $("span, .overlay").click(function () {
      $(".show-img").fadeOut();
  });
  
});